import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { Rectangle } from 'recharts';

interface CustomCursorProps {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    stroke?: string;
    fill?: string;
    barWidth?: number;
}

const CustomCursor = ({
    x = 0,
    y = 0,
    width = 0,
    height = 0,
    barWidth = 0,
}: CustomCursorProps) => {
    const { theme } = useTheme();
    return (
        <Rectangle
            fill={theme.palette.grey[100]}
            x={x - width / 2}
            y={y - barWidth}
            width={width}
            height={height + barWidth}
        />
    );
};

export default CustomCursor;
